var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _radialGradient;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaebesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 470,
    height: 610,
    viewBox: "0 0 124.354 161.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "k",
    x1: -154.733,
    x2: -155.284,
    y1: 153.706,
    y2: 111.505,
    gradientTransform: "matrix(1.96679 0 0 1.96679 474.418 -153.445)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0a2328",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#2e595f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2a4c52",
      stopOpacity: 1
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "j",
    x1: -168.259,
    x2: -201.944,
    y1: 114.522,
    y2: 150.506,
    gradientTransform: "matrix(1.96679 0 0 1.96679 474.418 -153.445)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06232b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    style: {
      stopColor: "#2b4c55",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2b4a53",
      stopOpacity: 1
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "h",
    x1: 7.614,
    x2: 27.614,
    y1: 138.719,
    y2: 192.429,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0a272f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#325b61",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2d5c62",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90c83f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#7ea942",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6f8e46",
      stopOpacity: 1
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "f",
    x1: -154.444,
    x2: -135.814,
    y1: 173.122,
    y2: 137.925,
    gradientTransform: "matrix(1.96679 0 0 1.96679 474.418 -153.445)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#143537",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    style: {
      stopColor: "#1f3e46",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#254249",
      stopOpacity: 1
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#d",
    id: "g",
    cx: -166.518,
    cy: 146.193,
    r: 11.827,
    fx: -166.518,
    fy: 146.193,
    gradientTransform: "matrix(1.96679 0 0 1.96679 474.418 -153.445)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11.113 107.558h41.108v89.745h-41.108z",
    style: {
      opacity: 1,
      fill: "#ffc400",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.02645833,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.26 -69.495) scale(.98537)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.912,
    cy: 134.086,
    r: 35.771,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.45692652,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.912,
    cy: 134.086,
    r: 33.248,
    fill: "none",
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 0,
      stroke: "none",
      strokeWidth: 0.42469656,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.61 70.549c-11.89-.138-21.347 2.541-30.033 6.889-8.79 4.399-20.226 14.78-25.303 22.965-11.85 19.108-12.838 42.143-2.675 62.42 5.464 10.905 24.694 35.749 51.771 66.891 2.19 2.518 4.104 4.588 4.257 4.602.81.07 10.96-11.195 20.826-23.115 20.652-24.95 34.225-46.469 39.97-63.365 1.841-5.416 1.981-6.272 2.185-13.441.31-10.937-1.493-18.973-6.484-28.89-9.504-18.882-28.553-33.137-49.263-34.722a81.149 81.149 0 0 0-5.25-.234zm-1.698 31.34a32.197 32.197 0 0 1 32.197 32.197 32.197 32.197 0 0 1-32.197 32.196 32.197 32.197 0 0 1-32.197-32.196 32.197 32.197 0 0 1 32.197-32.197z",
    style: {
      fill: "url(#f)",
      fillOpacity: 1,
      strokeWidth: 0.52585691
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.912,
    cy: 134.086,
    r: 23.261,
    style: {
      opacity: 1,
      fill: "url(#g)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.29711974,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.998 113.888c-6.046-.07-10.854 1.292-15.27 3.503-4.47 2.237-10.284 7.514-12.866 11.677-6.025 9.715-6.527 21.427-1.36 31.737 2.779 5.544 12.556 18.176 26.323 34.01 1.113 1.28 2.087 2.332 2.164 2.34.413.035 5.573-5.692 10.59-11.753 10.5-12.686 17.401-23.627 20.322-32.218.936-2.753 1.007-3.188 1.11-6.834.159-5.56-.758-9.646-3.296-14.689-4.832-9.6-14.518-16.848-25.047-17.653a41.26 41.26 0 0 0-2.67-.12zm-.863 15.935a16.37 16.37 0 0 1 16.37 16.37 16.37 16.37 0 0 1-16.37 16.37 16.37 16.37 0 0 1-16.37-16.37 16.37 16.37 0 0 1 16.37-16.37z",
    clipPath: "url(#i)",
    style: {
      fill: "url(#h)",
      fillOpacity: 1,
      strokeWidth: 0.26736841
    },
    transform: "matrix(1.96679 0 0 1.96679 87.644 -153.445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.707 70.532c-15.679.09-31.223 6.318-42.503 17.243-8.327 7.362-14.635 16.96-17.82 27.627-4.353 13.95-3.418 29.303 2.086 42.786.115.246.228.495.345.735 11.276-47.176 33.584-57.634 57.892-57.893z",
    style: {
      fill: "url(#j)",
      fillOpacity: 1,
      strokeWidth: 0.52585691
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.61 70.549a76.246 76.246 0 0 0-1.903.005v30.476c2.103.313 4.07.79 5.916 1.398a32.197 32.197 0 0 1 26.486 31.657 32.197 32.197 0 0 1-23.663 31.041c-.739.244-1.5.446-2.278.616 52.123-6.138 52.5-55.663 51.546-56.882l.002-.006a81.375 81.375 0 0 0-1.593-3.35c-9.503-18.882-28.553-33.137-49.262-34.722a81.15 81.15 0 0 0-5.25-.235zm4.558 95.193c-.598.07-1.201.138-1.813.196a32.197 32.197 0 0 1-4.358.341 24.622 24.622 0 0 0 6.17-.537zm-6.468.53h-.026c.03.003.059.001.089.003a32.197 32.197 0 0 1-.063-.004z",
    style: {
      fill: "url(#k)",
      fillOpacity: 1,
      strokeWidth: 0.52585691
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaebesLogo);
export default __webpack_public_path__ + "static/media/caebes-logo.cd78d1fc15fbd14f0f3c43b65069ca88.svg";
export { ForwardRef as ReactComponent };